module.exports = __webpack_public_path__ + "img/dsl-logo.63e1dc7b.jpg";